import { RouteIdEnum } from 'config/enums'
import DashboardLayout from 'layouts/layouts/DashboardLayout/DashboardLayout'
import SubscriptionsManagementTable from './SubscriptionsManagementTable'
import { useState } from 'react'
import TypesTabs from './TypeTabs'

const Index = () => {
    const [currentTab, setCurrentTab] = useState(0)
    return (
        <DashboardLayout
            title={"Gestion des Abonnements"}
            selectedPath={RouteIdEnum.SubscriptionsManagement}
        >
            <TypesTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />
            <SubscriptionsManagementTable currentTab={currentTab} />
            
        </DashboardLayout>
    )
}

export default Index